import React from 'react';
import PropTypes from 'prop-types';
import Suggestion from 'search-suggestion';
import { DebounceInput } from 'react-debounce-input';
import history from '../../auth/history';

import SearchClearButton from './SearchClearButton';
import SearchInputBox from './SearchInputBox';
import ItemList from './ItemList';
import Item from './Item';

import './styles/searchBar.scss';

export default class SearchBar extends React.Component {
  handleChange = e => {
    const keyword = e.target && e.target.value;
    if (keyword) {
      this.props.queryShowsAndEpisodes(keyword);
    } else {
      this.props.queryShowsAndEpisodes();
    }
  };

  handleItemClick = item => {
    if (item.type === 'SHOW') {
      history.push(`/${item.id}`);
    } else {
      history.push(`/e/${item.id}`);
    }
  };

  getSearchWords = inputValue => {
    const searchWords = inputValue && inputValue.split(/\s/).filter(word => word);
    return searchWords;
  };

  splitResultLists = items => {
    let shows = [];
    let episodes = [];
    let trending = [];

    items.forEach(item => {
      if (item.type === 'SHOW') {
        shows.push(item);
      } else if (item.type === 'EPISODE') {
        episodes.push(item);
      } else if (item.type === 'TRENDING') {
        trending.push(item);
      }
    });

    return { shows, episodes, trending };
  };

  render() {
    const { data } = this.props;
    const { shows, episodes, trending } = this.splitResultLists(data);

    return (
      <div>
        <Suggestion getDisplayName={item => item.title} items={data}>
          {({
            getInputProps,
            getListItemProps,
            getItemProps,
            inputValue,
            highlightedIndex,
            items,
            isOpen,
            selectedItem,
            clearInputValue,
          }) => (
            <div className='search-bar-container'>
              <DebounceInput
                minLength={3}
                debounceTimeout={800}
                element={SearchInputBox}
                {...getInputProps({
                  placeholder: 'Search by topic, show, or episode',
                  onChange: this.handleChange,
                })}
              />
              {inputValue && (
                <SearchClearButton
                  onClick={() => {
                    inputValue = '';
                    clearInputValue();
                    this.handleChange('');
                  }}
                />
              )}
              {isOpen && (
                <div className={'search-item-list-container' + (isOpen && inputValue.length && ' visible')}>
                  {!!shows.length && (
                    <React.Fragment>
                      <div className='search-show-label'>Shows</div>
                      <ItemList {...getListItemProps()}>
                        {shows.map((item, index) => (
                          <Item
                            {...getItemProps({ item, index })}
                            key={item.id}
                            item={item}
                            searchWords={this.getSearchWords(inputValue)}
                            highlightedIndex={highlightedIndex}
                            onClick={this.handleItemClick.bind(this, item)}
                            style={{
                              fontWeight: selectedItem && selectedItem.title === item.title ? 'bold' : 'normal',
                            }}
                          />
                        ))}
                      </ItemList>
                    </React.Fragment>
                  )}
                  {!!episodes.length && (
                    <React.Fragment>
                      <div className='search-episode-label'>Episodes</div>
                      <ItemList {...getListItemProps()}>
                        {episodes.map((item, index) => (
                          <Item
                            {...getItemProps({ item, index })}
                            key={item.id}
                            item={item}
                            searchWords={this.getSearchWords(inputValue)}
                            highlightedIndex={highlightedIndex}
                            onClick={this.handleItemClick.bind(this, item)}
                            style={{
                              fontWeight: selectedItem && selectedItem.title === item.title ? 'bold' : 'normal',
                            }}
                          />
                        ))}
                      </ItemList>
                    </React.Fragment>
                  )}
                  {!!trending.length && (
                    <React.Fragment>
                      <div className='search-episode-label'>Trending</div>
                      <ItemList {...getListItemProps()}>
                        {trending.map((item, index) => (
                          <Item
                            {...getItemProps({ item, index })}
                            key={item.id}
                            item={item}
                            searchWords={this.getSearchWords(inputValue)}
                            highlightedIndex={highlightedIndex}
                            onClick={this.handleItemClick.bind(this, item)}
                            style={{
                              fontWeight: selectedItem && selectedItem.title === item.title ? 'bold' : 'normal',
                            }}
                          />
                        ))}
                      </ItemList>
                    </React.Fragment>
                  )}
                </div>
              )}
            </div>
          )}
        </Suggestion>
      </div>
    );
  }
}

SearchBar.propTypes = {
  darkMode: PropTypes.bool,
};

SearchBar.defaultProps = {
  data: [],
  fetching: false,
};
